"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColoredBadge = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Badge = (0, _mui.styled)('div')(({
  theme,
  ownerState
}) => ({
  flexShrink: 0,
  width: theme.spacing(2),
  marginRight: theme.spacing(3),
  borderRadius: theme.spacing(2, 0, 0, 2),
  fontSize: '2rem',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  backgroundColor: ownerState.itemTheme,
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(4)
  }
}));
const ColoredBadge = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(Badge, {
  ownerState: props
});
exports.ColoredBadge = ColoredBadge;